//@ts-nocheck
import getFullFormInstance from "./getFullFormInstance";
/**
 * Upgrade form groups from the selected templates (if they are using them) to the new seleceted template.
 * This will update any field instances as needed to maintain their functionality in the app.
 * @param {Object} upgradeSelections the object containing the user specified configuration that the app
 * needs to change from one version to another.  This is the id of the original template as the key
 * and the new template as the value.
 * @return whether the operation was successful or not.
 */
async function convertFormGroups(upgradeSelections) {
	const fieldInstancesToUpdate = [];
	const formInstancesToUpdate = [];
	// all template map is for target template (so not actually all, just all target templates id: thing)
	const allTemplateMap = {};
	for (let i = 0; i < upgradeSelections.length; i++) {
		// This is basically looping over each type
		const upgradeSelection = upgradeSelections[i];
		const { source, target } = upgradeSelection;
		// need to transfer the instances in source from the form template in source
		// to the target form template.
		// start by looping through the instances..
		// going to need to map out the target field templates with baseFieldTemplate or the id as the key
		// because the default ones will not have a baseFieldTempate property..

		const targetFieldTemplateMap = {};

		// Use this base Template to Instance map to order em all up later on!
		// this map is the {table basetemplateid: { cellbasetemplateid: cell template},}
		for (let ii = 0; ii < target.fieldTemplates.items.length; ii++) {
			const targetFieldTemplate = target.fieldTemplates.items[ii];
			let baseTemplateId = targetFieldTemplate.baseFieldTemplate || targetFieldTemplate.id;
			allTemplateMap[targetFieldTemplate.id] = targetFieldTemplate;
			if (targetFieldTemplate.inputType === "table" || targetFieldTemplate.inputType === "imageroll") {
				// put the table fields in the map
				for (let iii = 0; iii < targetFieldTemplate.fieldTemplates.items.length; iii++) {
					const targetCellTemplate = targetFieldTemplate.fieldTemplates.items[iii];
					allTemplateMap[targetCellTemplate.id] = targetCellTemplate;
					// let cellBaseTemplateId = targetCellTemplate.baseFieldTemplate;
					// if(cellBaseTemplateId){
					//     if(targetCellFieldTemplateMap[baseTemplateId]){
					//         targetCellFieldTemplateMap[baseTemplateId][cellBaseTemplateId] = targetCellTemplate;
					//     }else{
					//         targetCellFieldTemplateMap[baseTemplateId] = {
					//             [cellBaseTemplateId]: targetCellTemplate
					//         };
					//     }
					// }else{
					//     console.error('Cell has undefined base template id: ', targetCellTemplate);
					// }
				}
			}
			if (baseTemplateId) {
				targetFieldTemplateMap[baseTemplateId] = targetFieldTemplate;
			} else {
				console.error("Unable to find baseTemplate id for field template: ", targetFieldTemplate);
			}
		}

		for (let ii = 0; ii < source.instances.length; ii++) {
			// going to make a copy of the main field template map, so we can remove things as we
			// convert things that exist in the source.  This should leave only ones that need
			// to be freshly created left at the end.
			let tempTargetFieldTemplateMap = { ...targetFieldTemplateMap };
			const formInstance = source.instances[ii];
			const fullFormInstance = await getFullFormInstance(formInstance.id);
			const baseTemplateToInstanceMap = {};
			let newFieldsOrder = [];
			// first just map out the instances to the instance map.  Each instance needs the baseTemplateId: instance
			for (let iii = 0; iii < fullFormInstance.fieldInstances.items.length; iii++) {
				const fieldInstanceToMap = fullFormInstance.fieldInstances.items[iii];
				const baseTemplateId = fieldInstanceToMap.fieldTemplate.baseFieldTemplate || fieldInstanceToMap.fieldTemplate.id;
				baseTemplateToInstanceMap[baseTemplateId] = fieldInstanceToMap;
			}

			// Now loop through the target template field order and grab each instance there, then things will
			// be ordered properly.
			for (let iii = 0; iii < target.fieldsOrder.length; iii++) {
				const baseTemplateId = target.fieldsOrder[iii];
				const fieldInstance = baseTemplateToInstanceMap[baseTemplateId];
				let sourceFieldTemplate;
				if (fieldInstance) {
					sourceFieldTemplate = fieldInstance.fieldTemplate;
				}
				const targetFieldTemplate = targetFieldTemplateMap[baseTemplateId];
				// GOING TO NEED TO CHANGE THIS FO RTABLE FIELD AND IMAGE ROlLS, the cells will be set as
				// the table fields on the converted field instance, so they need to be added to the batch, then
				// removed from this one before it is added to the batch.
				let convertedFieldInstance = fieldInstance
					? handleConvertSourceFieldTemplateToTarget(fieldInstance, sourceFieldTemplate, targetFieldTemplate, formInstance)
					: handleCreateNewFieldInstanceFromTemplate(targetFieldTemplate, formInstance);

				if (!targetFieldTemplate) {
					console.error("Error updating fields: Base Template undefined: ", sourceFieldTemplate);
				}

				// if (sourceFieldTemplate?.inputType === "table" || sourceFieldTemplate?.inputType === "imageroll") {
				// // let tempTableCellTemplateMap = targetCellFieldTemplateMap[sourceFieldTemplate];
				// // the source is a table so some fancy stuff needs to happen
				// // this is going to be {template.id : {instance.id: instance}}
				// // so we can first grab by template, then instance, and determine if new ones are needed.
				// let cellInstancesAdded = {};
				// // SHOULD ACTUALLY CHANGE THIS TO MAP OUT THEN GO THROUGH EACH ROW SO WE CAN DETERMINE WHICH
				// // CELLS NEED TO BE CREATED FRESH
				// for (let iv = 0; iv < fieldInstance.tableFields.items.length; iv++) {
				//     const sourceCellFieldInstance = fieldInstance.tableFields.items[iv];
				//     const sourceCellTemplate = sourceCellFieldInstance.fieldTemplate;
				//     let baseTemplateId = sourceCellTemplate.baseFieldTemplate || sourceCellTemplate.id;
				//     const targetCellTemplate = targetFieldTemplateMap[baseTemplateId];
				//     console.log('the source cell template: ', sourceCellTemplate);
				//     console.log('the target cell template: ', targetCellTemplate);
				//     if(targetCellTemplate){
				//         // this means it must use the targetCellTemplate instead of the one it has.
				//         const newCellFieldInstance = handleConvertSourceFieldTemplateToTarget(sourceCellFieldInstance, sourceCellTemplate, targetCellTemplate);
				//         fieldInstancesToUpdate.push(newCellFieldInstance);
				//         cellInstancesAdded[newCellFieldInstance.id] = newCellFieldInstance;
				//         // this isnt going to ork lke this anymore...
				//         // going to add it to another list, then at the end we will compare the added list
				//         // to tempTableCellTemplateMap and add in new field isntances for things taht are in the
				//         // latter and not in the former.
				//     }else{
				//         console.error("Error updating cells: Base template target cell template not found: ", sourceCellTemplate);
				//     }
				// }
				// // now need to check if there are any new field instances required.  Once again the old ones taht
				// // may have been removed will just remain here in case its reverted back at some point.
				// // ACTUALLY THIS IS WHERE WE WILL LOOP THROUGH ALL THE TABLE FIELDS AGAIN AND FIGURE OUT WHICH ONES WE
				// // NEED TO CREATE NEW AND ALSO MAINTAIN THE FIELDSORDER ON THE PARENT INSTANCE
				// // start by looping through the rowOrder and grab each group of instances based on the template id.
				// // if there are no instances for a template id, (templatea id is undefined in the map) then it
				// // is a new fresh one that needs to be created.
				// let newTableFieldsOrder = [];
				// // Trying the new idea here
				// // loopo through the parent table fields fieldsOrder, and loop over each id in each row
				// for (let iv = 0; iv < fieldInstance.fieldsOrder.length; iv++) {
				//     const rowKey = fieldInstance.fieldsOrder[iv];
				//     const rowIdsArray = rowKey.split(",");
				//     let rowTemplateInstanceMap = {};
				//     let newRowArray = [];
				//     // this is row of instances mapping out
				//     for (let v = 0; v < rowIdsArray.length; v++) {
				//         const existingCellFieldInstanceId = rowIdsArray[v];
				//         const existingCellFieldInstance = instancesAdded[existingCellFieldInstanceId];
				//         if(!existingCellFieldInstance){
				//             throw new Error("Cell Field Instance is undefined but in the fieldsORder: ", fieldInstance);
				//         }
				//         const instancesBaseTemplateId = existingCellFieldInstance.fieldTemplate.baseFieldTemplate || existingCellFieldInstance.fieldTemplate.id
				//         rowTemplateInstanceMap[instancesBaseTemplateId] = existingCellFieldInstance;
				//     }
				//     const newRowOrder = targetFieldTemplate.rowOrder;
				//     for (let v = 0; v < newRowOrder.length; v++) {
				//         const targetTemplateId = newRowOrder[v];
				//         const targetTemplateToSetupOrdering = allTemplateMap[targetTemplateId];
				//         const targetBaseTemplateId = targetTemplateToSetupOrdering.baseFieldTemplate || targetTemplateToSetupOrdering.id;
				//         const existingInstance = rowTemplateInstanceMap[targetBaseTemplateId]
				//         if(!existingInstance){
				//             // its a template that does not have an instance yet meaning this is a new field
				//             // added in.
				//             const newFieldInstances = handleCreateNewFieldInstanceFromTemplate(targetTemplateToSetupOrdering, formInstance);
				//             fieldInstancesToUpdate = fieldInstancesToUpdate.concat(newFieldInstances);
				//             newRowArray.push(newFieldInstance.id);
				//             // need to create then add the id to the fields order
				//         }else{
				//             // its an existing template, so add the ids to new order array
				//             newRowArray.push(existingInstance.id);
				//         }
				//     }
				//     const rowString = newRowArray.join(",");
				//     newTableFieldsOrder.push(rowString);
				// }
				// convertedFieldInstance.fieldsOrder = newFieldsOrder;
				// }

				fieldInstancesToUpdate.push(convertedFieldInstance);
				newFieldsOrder.push(convertedFieldInstance.id);
			}
			// Need to check if the target has more fields, then those will need to be added to the new
			// FormInstance - If there are less, then we just need to make sure the fieldsOrder is correct.
			// So this part is going to make sure the fieldsOrder is correct by creating
			// new fields for ones that are missing, and removing instances from the fields order
			// This will also make sure that all the ones that are included in the target are included
			// in the fieldsOrder (in case there is already a hidden one that is being reintroducered).
			// change the form instance form template id to the new one.

			// So basicaly whatever is left in the tempTargetFieldTemplateMap is what needs to be created
			// freshly, if this is incorrect then there is likely a bug in the previous block of code.
			// loop through each one of the templates that is left..
			const templatesThatNeedNewFieldInstances = Object.values(tempTargetFieldTemplateMap);
			for (let iii = 0; iii < templatesThatNeedNewFieldInstances.length; iii++) {
				const templateThatNeedsNewFieldInstance = templatesThatNeedNewFieldInstances[iii];
				// make a new field instance for this one:
				// THIS NEEDS TO BE WRAPPED UP WHEN THE OTHER PART IS COMPLETE SO WE CAN  test fully

				// if this is a table then we need to handle the cells which are going to be set as the
				// new field instance's table fields.  These just need to be added to the batch and removed
				// from this instance before it is added to the batch.
				const newFieldInstance = handleCreateNewFieldInstanceFromTemplate(templateThatNeedsNewFieldInstance, formInstance);
				fieldInstancesToUpdate.push(newFieldInstance);
				// NEED TO ADD TO FIELDS ORDER OR MANAGE THAT SOMEHOW

				// BAsically should map out the existing to templateId: instance
				// then loop through the new fieldsorder on the form template and if the template id
				// doesnt exist in the new templateId: instance map, then it needs to be freshly created.
				// then each one just pushes its id in a new fieldsOrder and we should be good to go.
			}
		}
	}

	// loop through the form group's form instances and check if the id exists in the upgradeConfigObject

	// if they exist then it needs to be upgraded.
	// go into next form instance, or next form group.
	// batch put the field instances and the form isntances
	// return error or true.
}

/**
 * Convert the source field instance to be compatible with the target template.  This will parse
 * the hfield instance value properly based on the requirements and the situation.
 */
function handleConvertSourceFieldTemplateToTarget(fieldInstance, source, target, formInstance) {
	let newFieldInstance;
	// Do the stuff for the conversion
	// if it needs to be upgraded then we need to loop over every field instance and determine if it needs
	// to be mutated to continute working
	// Text to checkbox
	// check box to a different checkbox
	// check box to text
	// change every field instance's fieldTemplateId to the new one.
	switch (source.inputType) {
		case "number":
		case "note":
		case "date":
		case "phone":
		case "text":
		case "readonlytext":
			newFieldInstance = handleTextSourceConversion(fieldInstance, source, target, formInstance);
			break;
		case "image":
			// image is just going to stay the same and stay in the bucket.  I dont think we need to convert
			// image fields to anything else, YET
			newFieldInstance = handleNoConversionRequired(fieldInstance, target, formInstance);
			break;
		case "checkbox":
		case "dropdown":
		case "radio":
			newFieldInstance = handlePicklistSourceConversion(fieldInstance, source, target, formInstance);
			break;
		// image roll and tables arent going to need much, they are setup like this for potential future things they will need
		// but right now, they are getting the no conversion flow
		case "imageroll":
		case "table":
			newFieldInstance = handleTableSourceConversion(source, target, fieldInstance, formInstance);
			break;
		default:
			throw new Error("Type not recognized converting beginning conversion: ", fieldInstance);
	}
	return newFieldInstance;
}

/**
 * hanles specific types that are not allowed to change input types (image for now)
 * @param {FieldInstance} fieldInstance the one to convert
 * @param {FieldTemplate} target field template to convert the field to.
 * @returns converted field instance
 */
function handleNoConversionRequired(fieldInstance, target, formInstance) {
	const newFieldInstance = { ...fieldInstance, fieldTemplateId: target.id };
	return newFieldInstance;
}

function handleTextSourceConversion(fieldInstance, source, target, formInstance) {
	let newFieldInstance;
	switch (target.inputType) {
		case "number":
		case "note":
		case "date":
		case "phone":
		case "text":
		case "readonlytext":
		case "image":
			// None of these will need anything done to the value so no conversion
			newFieldInstance = handleNoConversionRequired(fieldInstance, target, formInstance);
			break;
		case "imageroll":
		case "table":
			newFieldInstance = handleNonTableToTableConversion(source, target, fieldInstance, formInstance);
			break;
		case "checkbox":
		case "dropdown":
		case "radio":
			newFieldInstance = handleTextToPicklistType(fieldInstance, source, target, formInstance);
			break;
		default:
			throw new Error("Type not recognized converting from text type to x: ", fieldInstance);
	}
	return newFieldInstance;
}

function handlePicklistSourceConversion(fieldInstance, source, target, formInstance) {
	let newFieldInstance;
	// Picklist conversion is going to find the current selected option and use that to determine the new value
	// if the target is a picklist, we need to try to select an option based on the selected label/value vs. target label/value
	switch (target.inputType) {
		case "image":
		case "readonlytext":
			// we can just keep these the same, since it is readonly or tables with no value, then the value can be maintained if they switch it again
			// Might have to do something to setup new cells (will know from testing) NEW_CELLS
			newFieldInstance = handleNoConversionRequired(fieldInstance, target, formInstance);
			break;
		case "number":
		case "note":
		case "date":
		case "phone":
		case "text":
			newFieldInstance = handlePicklistToTextType(fieldInstance, target, formInstance);
			break;
		case "imageroll":
		case "table":
			newFieldInstance = handleNonTableToTableConversion(source, target, fieldInstance, formInstance);
			break;
		case "checkbox":
		case "dropdown":
		case "radio":
			newFieldInstance = handlePicklistToPicklistConversion(source, target, fieldInstance, formInstance);
			break;
		default:
			throw new Error("Type not recognized converting from picklist to x: ", fieldInstance);
	}

	return newFieldInstance;
}

function handlePicklistToPicklistConversion(source, target, fieldInstance, formInstance) {
	// converts one picklist to another picklist.
	// First get the option that is currently selected
	// parse out that label and value
	// loop through all the target options
	// parse out the label and vvalue and compare to the label and value of the current seleciton.
	// If its a match setup the value to use the new id.
	let newFieldInstance = { ...fieldInstance };
	let selectedOption;
	for (let i = 0; i < source.options.items.length; i++) {
		const option = source.options.items[i];
		if (option.id === fieldInstance.value) {
			// found the option
			selectedOption = option;
		}
	}

	const { label, value } = selectedOption;
	const upperCaseTrimmedLabel = Regex.Replace(label, "B[!-/;-@]+s*\b", "").toUpperCase();
	const upperCaseTrimmedOptionValue = Regex.Replace(value, "B[!-/;-@]+s*\b", "").toUpperCase();

	let match;
	for (let i = 0; i < target.options.items.length; i++) {
		const targetOption = target.options.items[i];
		const upperCaseTrimmedTargetLabel = Regex.Replace(targetOption.label, "B[!-/;-@]+s*\b", "").toUpperCase();
		const upperCaseTrimmedTargetOptionValue = Regex.Replace(targetOption.value, "B[!-/;-@]+s*\b", "").toUpperCase();

		// Check if either of them match either of the source ones
		if (
			upperCaseTrimmedLabel === upperCaseTrimmedTargetLabel ||
			upperCaseTrimmedLabel === upperCaseTrimmedTargetOptionValue ||
			upperCaseTrimmedOptionValue === upperCaseTrimmedTargetOptionValue ||
			upperCaseTrimmedOptionValue === upperCaseTrimmedTargetLabel
		) {
			// use the label
			match = targetOption;
			break;
		}
	}

	if (match) {
		// there was a match!
		// set value to use new id:
		newFieldInstance.value = match.id;
	} else {
		// match could not be found, so going to clear the entry and put NOT_converted with previous value in revision.
		newFieldInstance.value = "NOT_CONVERTED";
	}

	return newFieldInstance;
}

function handleTableSourceConversion(source, target, fieldInstance, formInstance) {
	// since tables never have values this is pretty straightforward, just set new field template id
	// The cells can continue to exist as they are, and since the new input type will be text, they will
	// simply not be pulled in.  Then if converted back as long as the id is maintained the pre-existing table fields
	// should continue to be pulled in
	let newFieldInstance;
	switch (target.inputType) {
		case "number":
		case "note":
		case "date":
		case "phone":
		case "text":
		case "readonlytext":
		case "image":
		case "checkbox":
		case "dropdown":
		case "radio":
			// Most things going from table to something else do not need any action to convert.
			newFieldInstance = handleNoConversionRequired(fieldInstance, target, formInstance);
			break;
		case "imageroll":
		case "table":
			// Table to table conversion.
			newFieldInstance = handleTableToTableConversion(source, target, fieldInstance, formInstance);
			break;
		default:
			throw new Error("Type not recognized converting from table to x: ", fieldInstance);
	}

	return newFieldInstance;
}

function handlePicklistToTextType(fieldInstance, target, formInstance) {
	// need to parse the id to the option label text -
	// loop through the options
	let newValue = "";
	for (let i = 0; i < target.options.items.length; i++) {
		const option = target.options.items[i];
		if (option.id === fieldInstance.value) {
			// found the option
			newValue = option.label;
		}
	}
	const newFieldInstance = {
		...fieldInstance,
		fieldTemplateId: target.id,
		value: newValue,
	};

	return newFieldInstance;
}

function handleTextToPicklistType(fieldInstance, target, formInstance) {
	// need to try to match the text value to an option label first then try value, if none can match then put in
	// a statement saying it could not be matched.
	// if the initial value is empty then just put an empty string.
	let newFieldInstance = { ...fieldInstance };
	const ogValue = fieldInstance.value;
	if (ogValue === "") {
		// just use the empty string and move on
	}
	// loop through the options
	for (let i = 0; i < target.options.items.length; i++) {
		const optionToCheck = target.options.items[i];
		const { label, value, id } = optionToCheck;

		const upperCaseTrimmedLabel = Regex.Replace(label, "B[!-/;-@]+s*\b", "").toUpperCase();
		const upperCaseTrimmedOptionValue = Regex.Replace(value, "B[!-/;-@]+s*\b", "").toUpperCase();
		const upperCaseTrimmedOgValue = Regex.Replace(ogValue, "B[!-/;-@]+s*\b", "").toUpperCase();
		if (upperCaseTrimmedLabel === upperCaseTrimmedOgValue) {
			// use the label
			newFieldInstance.value = id;
			break;
		} else if (upperCaseTrimmedOptionValue === upperCaseTrimmedOptionValue) {
			// use the value
			newFieldInstance.value = id;
			break;
		} else {
			// couldnt convert value going to set to "NOT_CONVERTED"
			newFieldInstance.value = "NOT_CONVERTED";
			break;
		}
	}

	newFieldInstance.fieldTemplateId = target.id;
	return newFieldInstance;
}

/**
 * Handles converting non table types to a table.  This pretty much involves just setting up all the new cells
 * and making sure the fields order is correct.  The new fields will be set as table fields, so they will
 * need to be handled for batch put after this module.
 * @param {FieldTemplate} source template that defines the field instances existing specifics
 * @param {FieldTemplate} target template that the field instance needs to be converted to.
 * @param {FieldInstance} fieldInstance that needs to be converted.
 */
function handleNonTableToTableConversion(source, target, fieldInstance, formInstance) {
	const newTableFields = [];
	const newFieldsOrder = [];
	// First check if the fieldInstance used to be a table (it will have tableFields and fieldsOrder)
	// if it is, then we should use the table to table conversion and simply return the result of that.
	if (fieldInstance.fieldsOrder && fieldInstance.fieldsOrder.length > 0 && fieldInstance.tableFields.items && fieldInstance.tableFields.items.length > 0) {
		// it was a table at one point, so do the table to table conversion
		const newField = handleTableToTableConversion(source, target, fieldInstance, formInstance);
		return newField;
	} else {
		// it has never been a table to the cells need to be setup from scratch.
		// it will need fresh everything so it needs to basically setup an empty table off
		// the target templates.
		const newFieldsMap = {};
		// first loop through all the template in tableFields in the target, and create fresh instance for each one
		// then put it in array with template Id: new Instance for ordering in the next part.
		for (let i = 0; i < target.tableFields.items.length; i++) {
			const cellTemplate = target.tableFields.items[i];
			const newCellInstance = handleCreateNewFieldInstanceFromTemplate(cellTemplate, formInstance, fieldInstance);
			newFieldsMap[cellTemplate.id] = newCellInstance;
		}
		const newRowOrder = [];
		for (let i = 0; i < target.rowOrder.length; i++) {
			const templateId = target.rowOrder[i];
			const instance = newFieldsMap[templateId];
			newRowOrder.push(instance.id);
			newTableFields.push(instance);
		}

		const newRowKey = newRowOrder.join(",");
		newFieldsOrder.push(newRowKey);

		fieldInstance.fieldsOrder = newFieldsOrder;
		fieldInstance.tableFields = newTableFields;
		fieldInstance.fieldTemplateId = target.id;
		fieldInstance.fieldTemplate = target;
		return fieldInstance;
	}
}

/**
 * Handles converting a table to another table.
 * @param {FieldTemplate} source template that defines the field instance.
 * @param {FieldTemplate} target template that defines the conversion goal or target
 * @param {FieldInstance} fieldInstance that needs to be converted.
 * @param {FormInstance} formInstance that the fieldInstance belongs to.
 */
function handleTableToTableConversion(source, target, fieldInstance, formInstance) {
	//Ok starting from scratch again
	// 1. Loop through the source field instance and map out the existing cells - instance id: instance
	//    (the parent does not need to be added to this since it is the fieldInstance) also map out the templates
	// 2. loop through each row in the fieldOrder (fieldsOrder element .split (,)) and grab each instance by id.
	//    then add this instance to a row level map {baseTemplateId: instance}

	// 3. Still at the row level, Loop through the target template and using the baseFieldTemplate grab the existing instance
	//    if the existing instance does not exist, then it needs to be created fresh.
	// 4. each one of these will be pushed into a big batch tablefields array and its id added to a row array
	//    that will be joined and after the row added to the fieldsOrder array.
	// 5. set the fields order using the main fieldorder array and tableFields (new instances and existing) and return the table field.
	// the lists
	// for batch putting the instances (includes updating existing and new ones)
	const newTableFields = [];
	// for setting the parent's new fieldsOrder, each element is the rowkey (csv of feldInstance ids.)
	const newFieldsOrder = [];
	// the maps:
	// first is to have all the target templates with id: template.
	const targetTemplatesMap = {};
	// second is all the existing instances id: instance.
	const instanceMap = {};
	// step 1. - map the instances and target templates.
	for (let i = 0; i < fieldInstance.tableFields.items.length; i++) {
		const cellFieldInstance = fieldInstance.tableFields.items[i];
		instanceMap[cellFieldInstance.id] = instance;
	}

	for (let i = 0; i < target.tableFields.items.length; i++) {
		const cellTemplate = target.tableFields.items[i];
		targetTemplatesMap[cellTemplate.id] = cellTemplate;
	}

	// step 2. and step 3s.
	for (let i = 0; i < fieldInstance.fieldsOrder.length; i++) {
		// per row
		const rowKey = fieldInstance.fieldsOrder[i]; // csv of field instance ids
		const rowIdArray = rowKey.split(","); // array of field instance ids for the row.
		// this is a map to organize each row's field instances by its baseFieldTemplate id.  This is what we
		// can use to match an instance to a template in the target templates.
		const baseTemplateToInstanceByRowMap = {};
		// This next list is to store each field instance id to be joined and setup as the rowKey
		const newRowArray = [];
		// this is to map out existing fields to their baseTemplateId for the next part looping over the template
		// hoohah
		for (let ii = 0; ii < rowIdArray.length; ii++) {
			const instanceId = rowIdArray[ii];
			const existingFieldInstance = instanceMap[instanceId];

			if (!existingFieldInstance) {
				throw new Error("Instance is in fields Order of parent table but not in the map for conversion: ", instanceId, fieldInstance);
			}

			const baseTemplateId = existingFieldInstance.fieldTemplate.baseFieldTemplate || existingFieldInstance.fieldTemplate.id;
			baseTemplateToInstanceByRowMap[baseTemplateId] = existingFieldInstance;
		}

		// step 3. and 4. ish
		for (let ii = 0; ii < target.rowOrder.length; ii++) {
			const templateIdInRowOrder = target.rowOrder[ii];
			const targetTemplate = targetTemplatesMap[templateIdInRowOrder];
			const existingFieldInstance = baseTemplateToInstanceByRowMap[templateIdInRowOrder];

			if (!existingFieldInstance) {
				// it is a new template added so it needs a fresh new field instance then add that id to
				// fieldsOrder and put the cell in the batch.
				const newFieldInstance = handleCreateNewFieldInstanceFromTemplate(targetTemplate, formInstance, fieldInstance);
				newRowArray.push(newFieldInstance.id);
				newTableFields.push(newFieldInstance);
			} else {
				// it is an existing template so simply convert the field instance.  Add the id to the fieldsOrder
				// and put it in the array for tableFields.
				const convertedCell = handleConvertSourceFieldTemplateToTarget(existingInstance, existingInstance.fieldTemplate, targetTemplate, formInstance);
				// its an existing template/fieldInstance, so add the ids to new order array after converting.
				// -----------------------------------------------------------------------------------------
				// THIS SHOULD NOT BE A TABLE AT THIS POINT!!! IF IT IS THEN IT's CHILDREN NEED TO BE HANDLED
				// AT THIS POINT!!!!!! this is not handling children yet!!! (basically nested table which we dont support yet)
				// -----------------------------------------------------------------------------------------
				newRowArray.push(convertedCell.id);
				newTableFields.push(convertedCell);
			}
		}

		// just push the new rowKey into the new fieldsOrder so the instances are related to its parent properly.
		const rowString = newRowArray.join(",");
		newFieldsOrder.push(rowString);
	}
	// set the fieldsOrder and new table fields (not using items, since this will be removed by the function)
	// that called this.  If they are not being removed, then it will not update in the db.
	fieldInstance.fieldsOrder = newFieldsOrder;
	fieldInstance.tableFields = newTableFields;
	fieldInstance.fieldTemplateId = target.id;
	fieldInstance.fieldTemplate = target;
	// // let tempTableCellTemplateMap = targetCellFieldTemplateMap[sourceFieldTemplate];
	// // the source is a table so some fancy stuff needs to happen
	// // this is going to be {template.id : {instance.id: instance}}
	// // so we can first grab by template, then instance, and determine if new ones are needed.
	// let cellInstancesAdded = {};
	// let newTableFields = [];
	// // SHOULD ACTUALLY CHANGE THIS TO MAP OUT THEN GO THROUGH EACH ROW SO WE CAN DETERMINE WHICH
	// // CELLS NEED TO BE CREATED FRESH
	// for (let iv = 0; iv < fieldInstance.tableFields.items.length; iv++) {
	//     const sourceCellFieldInstance = fieldInstance.tableFields.items[iv];
	//     const sourceCellTemplate = sourceCellFieldInstance.fieldTemplate;
	//     let baseTemplateId = sourceCellTemplate.baseFieldTemplate || sourceCellTemplate.id;
	//     const targetCellTemplate = targetFieldTemplateMap[baseTemplateId];
	//     console.log('the source cell template: ', sourceCellTemplate);
	//     console.log('the target cell template: ', targetCellTemplate);
	//     if(targetCellTemplate){
	//         // this means it must use the targetCellTemplate instead of the one it has.
	//         const newCellFieldInstance = handleConvertSourceFieldTemplateToTarget(sourceCellFieldInstance, sourceCellTemplate, targetCellTemplate);
	//         fieldInstancesToUpdate.push(newCellFieldInstance);
	//         cellInstancesAdded[newCellFieldInstance.id] = newCellFieldInstance;
	//     }else{
	//         console.error("Error updating cells: Base template target cell template not found: ", sourceCellTemplate);
	//     }
	// }
	// // THIS IS WHERE WE WILL LOOP THROUGH ALL THE TABLE FIELDS AGAIN AND FIGURE OUT WHICH ONES WE
	// // NEED TO CREATE NEW AND ALSO MAINTAIN THE FIELDSORDER ON THE PARENT INSTANCE
	// // start by looping through the rowOrder and grab each group of instances based on the template id.
	// // if there are no instances for a template id, (templatea id is undefined in the map) then it
	// // is a new fresh one that needs to be created.
	// let newTableFieldsOrder = [];
	// // Trying the new idea here
	// // loopo through the parent table fields fieldsOrder, and loop over each id in each row
	// // basically linking all the existing cells to their base template id in a map, so later we can go through
	// // the new row order and convert existing instances, and create new ones as needed.
	// for (let iv = 0; iv < fieldInstance.fieldsOrder.length; iv++) {
	//     const rowKey = fieldInstance.fieldsOrder[iv];
	//     const rowIdsArray = rowKey.split(",");
	//     let rowTemplateInstanceMap = {};
	//     let newRowArray = [];
	//     // this is row of instances mapping out
	//     for (let v = 0; v < rowIdsArray.length; v++) {
	//         const existingCellFieldInstanceId = rowIdsArray[v];
	//         const existingCellFieldInstance = instancesAdded[existingCellFieldInstanceId];
	//         if(!existingCellFieldInstance){
	//             throw new Error("Cell Field Instance is undefined but in the fieldsORder: ", fieldInstance);
	//         }
	//         const instancesBaseTemplateId = existingCellFieldInstance.fieldTemplate.baseFieldTemplate || existingCellFieldInstance.fieldTemplate.id
	//         rowTemplateInstanceMap[instancesBaseTemplateId] = existingCellFieldInstance;
	//     }

	//     const newRowOrder = targetFieldTemplate.rowOrder;
	//     for (let v = 0; v < newRowOrder.length; v++) {
	//         const targetTemplateId = newRowOrder[v];
	//         const targetTemplateToSetupOrdering = allTemplateMap[targetTemplateId];
	//         const targetBaseTemplateId = targetTemplateToSetupOrdering.baseFieldTemplate || targetTemplateToSetupOrdering.id;
	//         const existingInstance = rowTemplateInstanceMap[targetBaseTemplateId]
	//         if(!existingInstance){
	//             // its a template that does not have an instance yet meaning this is a new field
	//             // added in.
	//             const newFieldInstances = handleCreateNewFieldInstanceFromTemplate(targetTemplateToSetupOrdering, formInstance);
	//             fieldInstancesToUpdate = fieldInstancesToUpdate.concat(newFieldInstances);
	//             newRowArray.push(newFieldInstance.id);
	//             newTableFields.push(newFieldInstance);
	//             // need to create then add the id to the fields order
	//         }else{

	//             const convertedCell = handleConvertSourceFieldTemplateToTarget(existingInstance, existingInstance.fieldTemplate, targetTemplateToSetupOrdering);
	//             // its an existing template/fieldInstance, so add the ids to new order array after converting
	//             newRowArray.push(convertedCell.id);
	//             newTableFields.push(convertedCell);
	//         }
	//     }
	//     const rowString = newRowArray.join(",");
	//     newTableFieldsOrder.push(rowString);

	// }
	// convertedFieldInstance.fieldsOrder = newFieldsOrder;
	// convertedFieldInstance.tableFields = newTableFields;
	// return convertedFieldInstance;
	return fieldInstance;
}

/**
 * Creates a new field instance based on the target template.  This will also create cells and add them to the
 * parent fields' table fields property.
 * @param {FieldTemplate} targetTemplate that is needed to convert the field instance to
 * @param {FormInstance} formInstance that the field's belong to.
 * @param {FieldInstance} [parentTableField] (if applicable) the parent field to this field if its a cell.
 * @returns New field instance.
 */
function handleCreateNewFieldInstanceFromTemplate(targetTemplate, formInstance, parentTableField) {
	let newFieldInstances = [];
	// THIS NEEDS TO HANDLE NEW TABLE FIELDS if the target template is a table.
	// This is going to setup new cells for each template cell then add to the returned instance as
	// table fields.
	if (targetTemplate.inputType === "table" || targetTemplate.inputType === "imageroll") {
		// NEED TO BUILD OUT THE CHILDREN.
		for (let i = 0; i < targetTemplate.tableFields.items.length; i++) {
			const cellTemplate = targetTemplate.tableFields.items[i];
		}
	}
	const timestamp = Date.now().toISOString();
	const id = uuid();
	const newFieldInstance = {
		id,
		fieldTemplateId: targetTemplate.id,
		value: "",
		formGroup: formInstance.formGroup,
		authors: [],
		lastAuthor: "",
		group: formInstance.group,
		createdAt: timestamp,
		updatedAt: timestamp,
	};

	if (parentTableField) {
		newFieldInstance.tableField = parentTableField.id;
	} else {
		newFieldInstance.formInstance = formInstance.id;
	}

	newFieldInstances.push(newFieldInstance);

	return newFieldInstances;
}

export { convertFormGroups, handleConvertSourceFieldTemplateToTarget };
